"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookieDomainPart = exports.getBaseDomain = exports.getIsNaniDomain = exports.ONECLASS_DOMAIN = exports.NANI_DOMAIN = void 0;
var NANI_DOMAIN = "nani.com.tw";
exports.NANI_DOMAIN = NANI_DOMAIN;
var ONECLASS_DOMAIN = "oneclass.com.tw";
/**
 * 當前是否為 nani 網域
 * @returns {boolean}
 */

exports.ONECLASS_DOMAIN = ONECLASS_DOMAIN;

var getIsNaniDomain = function getIsNaniDomain() {
  return window.location.hostname.endsWith(NANI_DOMAIN);
};
/**
 * 取得父網域，給 cookie domain 與跨系統連結共用
 * @returns {string|null} localhost / IP 等非正式網域回傳 null（cookie 不設 domain）
 */


exports.getIsNaniDomain = getIsNaniDomain;

var getBaseDomain = function getBaseDomain() {
  var hostname = window.location.hostname;
  if (hostname.endsWith(NANI_DOMAIN)) return NANI_DOMAIN;
  if (hostname.endsWith(ONECLASS_DOMAIN)) return ONECLASS_DOMAIN;
  return null;
};
/**
 * 組 cookie 的 domain 片段
 * @returns {string} 非正式網域回傳空字串，讓 cookie 只綁在當前 host
 */


exports.getBaseDomain = getBaseDomain;

var getCookieDomainPart = function getCookieDomainPart() {
  var baseDomain = getBaseDomain();
  return baseDomain ? ";domain=".concat(baseDomain) : "";
};

exports.getCookieDomainPart = getCookieDomainPart;